import React, {PropsWithChildren, useEffect, useRef, useState} from 'react';
import {IonDatetime, IonPopover} from '@ionic/react';
import {DatetimePresentation} from "@ionic/core";
import {StyledFakeField} from "./input.style";
import {isValid, parseISO} from "date-fns";
import {StyledIonModal} from "../../modal/modal.style";
import {StyledDate} from "./date.style";

const MomentRange = require('moment-range');
const Moment = require('moment-timezone')
const moment = MomentRange.extendMoment(Moment);
moment.tz.setDefault('Europe/Warsaw');

type DateProps = {
    value?: string | string[] | null;
    disabled?: boolean;
    max?: string;
    min?: string;
    cancelText?: string;
    doneText?: string;
    placeholder?: string;
    presentation: DatetimePresentation;
    format: string;
    onChange: (value: string) => void;
    onFocus?: (e: any) => void;
    onCancel?: (e: any) => void;
    className?: string;
    minuteValues?: number[] | number | string;
    keepContentsMounted?: boolean;
    popover?: boolean;
    onWillPresent?: (e: any) => void;
}

const DateInput: React.FC<PropsWithChildren<DateProps>> = (props) => {
    const [showPicker, updateShowPicker] = useState(false);
    const [formattedValue, updateFormattedValue] = useState<string>(props.placeholder ?? '');

    useEffect(() => {
        if (props.value && isValid(parseISO(props.value.toString()))) {
            updateFormattedValue(moment(props.value.toString(), moment.ISO_8601).format(props.format))
        }
    }, [props.value]);

    const datetime = useRef<null | HTMLIonDatetimeElement>(null);

    return (
        <StyledDate>
            <StyledFakeField className={props.className} onClick={() => {
                if (!props.disabled) {
                    updateShowPicker(true)
                }
            }}>
                {formattedValue}
            </StyledFakeField>
            {props.popover &&
                <IonPopover
                    keepContentsMounted={props.keepContentsMounted}
                    isOpen={showPicker}
                    onWillPresent={(e) => {
                        if (props.onWillPresent) {
                            props.onWillPresent(e);
                        }
                    }}
                    onDidDismiss={() => updateShowPicker(false)}
                >
                    <IonDatetime
                        // to prevent onIonChange infinite loop
                        key={Math.random()}
                        hourCycle="h23"
                        ref={datetime}
                        value={props.value}
                        showDefaultButtons={true}
                        presentation={props.presentation}
                        doneText={props.doneText}
                        cancelText={props.cancelText}
                        min={props.min}
                        max={props.max}
                        minuteValues={props.minuteValues}
                        onIonFocus={(e) => {
                            if (props.onFocus) {
                                props.onFocus(e);
                            }
                        }}
                        onIonCancel={(e) => {
                            if (props.onCancel) {
                                props.onCancel(e);
                            }
                        }}
                        onIonChange={(e) => {
                            if (e.detail.value) {
                                props.onChange(moment(e.detail.value.toString(), moment.ISO_8601).format())
                                updateShowPicker(false);
                            }
                        }}
                    />
                </IonPopover>
            }
            {!props.popover &&
                <StyledIonModal
                    keepContentsMounted={props.keepContentsMounted}
                    className="date-picker"
                    isOpen={showPicker}
                    onDidDismiss={() => updateShowPicker(false)}
                    initialBreakpoint={0.53}
                    breakpoints={[0, 0.53, 0.99]}
                >
                    <IonDatetime
                        // to prevent onIonChange infinite loop
                        key={Math.random()}
                        ref={datetime}
                        size="cover"
                        hourCycle="h23"
                        value={props.value}
                        showDefaultButtons={true}
                        presentation={props.presentation}
                        doneText={props.doneText}
                        cancelText={props.cancelText}
                        min={props.min}
                        max={props.max}
                        minuteValues={props.minuteValues}
                        onIonFocus={(e) => {
                            if (props.onFocus) {
                                props.onFocus(e);
                            }
                        }}
                        onIonCancel={(e) => {
                            if (props.onCancel) {
                                props.onCancel(e);
                            }
                        }}
                        onIonChange={(e) => {
                            if (e.detail.value) {
                                props.onChange(moment(e.detail.value.toString(), moment.ISO_8601).format())
                                updateShowPicker(false);
                            }
                        }}
                    />
                </StyledIonModal>
            }
        </StyledDate>
    );
}
export default DateInput;